const SiteVersionIndex = () => import('./views/SiteVersionIndex.vue')
const SiteVersionCreate = () => import('./views/SiteVersionCreate.vue')
const SiteVersionEdit = () => import('./views/SiteVersionEdit.vue')

export default [
  {
    path: 'site-versions',
    name: 'site-versions.index',
    component: SiteVersionIndex
  },
  {
    path: 'site-versions/create',
    name: 'site-versions.create',
    component: SiteVersionCreate
  },
  {
    path: 'site-versions/:siteVersionId(\\d+)',
    name: 'site-versions.edit',
    component: SiteVersionEdit
  }
]
